import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivityInterface, WorkflowStepInterface } from '@vendasta/automata';
import { Observable } from 'rxjs';
import { ActivityTableEntry, AutomationDisplayService, NodeData } from '../../common/automation-display.service';
import { StringFormattingService } from '../../../services';

@Injectable({ providedIn: 'root' })
export class AddTagsToOrderService extends AutomationDisplayService {
  constructor(
    protected readonly formatter: StringFormattingService,
    protected readonly translateService: TranslateService,
  ) {
    super();
  }

  /** Gets text for the activity column in the table. */
  getActivityColumn(_namespace: string, activity: ActivityInterface): ActivityTableEntry {
    // Check for problems creating the tag.
    const data = activity?.workflowStep?.data ? JSON.parse(activity.workflowStep.data) : {};
    if (activity?.error || !data.tags) {
      return this.tableEntry(
        this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.ADD_TAGS_TO_ORDER.ACTIVITY.FAILED_TO_ADD_TAGS'),
        this.emptyBody(),
      );
    }

    // Show user-friendly text if the step proceeded.
    const subtitle =
      data.tags.length === 1
        ? 'AUTOMATIONS.EDITOR.TASKS.ADD_TAGS_TO_ORDER.ACTIVITY.SUBTITLE_SINGULAR'
        : 'AUTOMATIONS.EDITOR.TASKS.ADD_TAGS_TO_ORDER.ACTIVITY.SUBTITLE_PLURAL';
    return this.tableEntry(
      this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.ADD_TAGS_TO_ORDER.ACTIVITY.TITLE'),
      this.translateService.stream(subtitle, { tags: this.formatter.formatList(data.tags) }),
    );
  }

  /** The text in an automation node (i.e. the nodes in the graph). */
  getAutomationNodeData(
    _namespace: string,
    step: WorkflowStepInterface,
    _isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    const data = step?.data ? JSON.parse(step.data) : {};

    if (data.tags && data.tags.length > 0) {
      // Tags at this point should already be sanitized, so we simply have to format them.
      const subtitle =
        data.tags.length === 1
          ? 'AUTOMATIONS.EDITOR.TASKS.ADD_TAGS_TO_ORDER.ACTION.SUBTITLE_SINGULAR'
          : 'AUTOMATIONS.EDITOR.TASKS.ADD_TAGS_TO_ORDER.ACTION.SUBTITLE_PLURAL';
      return this.nodeDisplayData(
        this.translateService.stream(subtitle, { tags: this.formatter.formatList(data.tags) }),
        this.noValidationErrorsDetected(),
      );
    } else {
      return this.nodeDisplayData(
        this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.ADD_TAGS_TO_ORDER.ACTION.TITLE'),
        this.validationErrorsDetected(
          step,
          this.translateService.instant('AUTOMATIONS.EDITOR.TASKS.ADD_TAGS_TO_ORDER.ACTION.CONFIG_ERROR'),
          true,
        ),
      );
    }
  }
}
